import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import AuctionTemplateCreateTab from './AuctionTemplateCreateTab';
import { auctionTemplatePropertiesType } from '../../types';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';

CreateAuctionTemplateRow.propTypes = {
    auctionTemplateProps: auctionTemplatePropertiesType.isRequired,
};

function CreateAuctionTemplateRow(props) {
    const {
        auctionTemplateProps,
    } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-auction-template-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}>
                <FontAwesomeIcon icon="plus" />&nbsp;{t('auction-templates.create-auction-template')}
            </CreateButton>
            {isCreateVisible && (
                <AuctionTemplateCreateTab
                    hideHandler={() => setCreateVisible(false)}
                    auctionTemplateProps={auctionTemplateProps}
                />
            )}
        </div>
    );
}

export default withPrivileges([Privileges.AUCTION_TEMPLATE_EDIT])(CreateAuctionTemplateRow);
